import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';
import { INVOICE_PDF } from '@/graphql/mutations/billing';

type UseInvoicePdfResult = { invoicePdfUrl: (invoiceId: string) => Promise<string | null> };

/** Paddle's short-lived PDF link for one invoice. */
export function useInvoicePdf(): UseInvoicePdfResult {
  const [mutate] = useMutation(INVOICE_PDF, { fetchPolicy: 'no-cache' });

  const invoicePdfUrl = useCallback(
    async (invoiceId: string) => {
      const { data } = await mutate({ variables: { input: { invoiceId } } });
      return data?.invoicePdf.url ?? null;
    },
    [mutate],
  );

  return { invoicePdfUrl };
}
